import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-notification-popup',
    templateUrl: './notification-popup.component.html',
    styleUrls: ['./notification-popup.component.scss'],
    standalone: false
})
export class NotificationPopupComponent implements OnInit {
    @Input()
    notificationPopupMode: any;

    constructor(public activeModal: NgbActiveModal) {
    }

    ngOnInit() {
    }
}
